// extracted by mini-css-extract-plugin
module.exports = {"comp":"Screen3_comp__S3AIF"};